<pbc-filter [config]="FeldUnterkategoriesFilterConfig" [filter]="feldUnterkategories.filter$ | async" (filterChange)="feldUnterkategories.filter$.next($event)"></pbc-filter>
